import { Link } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import { Instagram, Mail } from "lucide-react";

export const Footer = () => {
  const { settings } = useStore();
  const brand = settings?.brand_name || "UpgradeMate";
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#0a0a0a] text-white" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-32">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
          <div>
            <p className="font-logo text-4xl">{brand}<span className="text-white/40">.</span></p>
            <p className="mt-4 max-w-xs text-sm text-white/50">Premium digital guides to help you build muscle, improve your lifestyle, attract better relationships and make more money.</p>
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-[0.2em] text-white/40">Explore</p>
            <div className="mt-5 flex flex-col gap-3 text-sm text-white/70">
              <Link to="/shop" className="hover:text-white" data-testid="footer-shop">Shop</Link>
              <Link to="/bundle" className="hover:text-white" data-testid="footer-bundle">Bundle</Link>
              <Link to="/about" className="hover:text-white" data-testid="footer-about">About</Link>
              <Link to="/faq" className="hover:text-white" data-testid="footer-faq">FAQ</Link>
              <Link to="/contact" className="hover:text-white" data-testid="footer-contact">Contact</Link>
            </div>
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-[0.2em] text-white/40">Legal & Social</p>
            <div className="mt-5 flex flex-col gap-3 text-sm text-white/70">
              <Link to="/legal/privacy" className="hover:text-white" data-testid="footer-privacy">Privacy Policy</Link>
              <Link to="/legal/terms" className="hover:text-white" data-testid="footer-terms">Terms</Link>
              <Link to="/legal/refund" className="hover:text-white" data-testid="footer-refund">Refund Policy</Link>
              <a href={settings?.social_instagram || "#"} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-white" data-testid="footer-instagram"><Instagram className="h-4 w-4" /> Instagram</a>
              <a href={`mailto:${settings?.social_email || "hello@upgrademate.com"}`} className="inline-flex items-center gap-2 hover:text-white" data-testid="footer-email"><Mail className="h-4 w-4" /> Email</a>
            </div>
          </div>
        </div>
        <div className="mt-16 border-t border-white/10 pt-8 text-xs text-white/40">
          © {year} {brand}. All rights reserved.
        </div>
      </div>
    </footer>
  );
};
